class TrustZoneSection extends HTMLElement {
  connectedCallback() {
    this._controls = new TrustZoneControls(this);
  }

  disconnectedCallback() {
    this._controls?.destroy();
    this._controls = null;
  }
}

class TrustZoneControls {
  constructor(root) {
    this.root = root;
    this.scroller = root.querySelector('.cos-slider');
    this.controls = root.querySelector('.trust-zone__controls');
    this.prevBtn = root.querySelector('.cos-slider__button--prev');
    this.nextBtn = root.querySelector('.cos-slider__button--next');
    this.resizeObserver = null;
    this._onUpdate = this.update.bind(this);

    if (!this.scroller || !this.controls || !this.prevBtn || !this.nextBtn) return;

    this.scroller.addEventListener('scroll', this._onUpdate, { passive: true });
    window.addEventListener('resize', this._onUpdate);

    if (typeof ResizeObserver === 'function') {
      this.resizeObserver = new ResizeObserver(this._onUpdate);
      this.resizeObserver.observe(this.scroller);
    }

    requestAnimationFrame(() => {
      this.update();
      setTimeout(this._onUpdate, 120);
    });
  }

  destroy() {
    this.scroller?.removeEventListener('scroll', this._onUpdate);
    window.removeEventListener('resize', this._onUpdate);
    this.resizeObserver?.disconnect();
  }

  update() {
    if (!this.scroller || !this.controls || !this.prevBtn || !this.nextBtn) return;

    const maxScroll = Math.max(0, this.scroller.scrollWidth - this.scroller.clientWidth);
    const canScroll = maxScroll > 2;
    const isAtStart = !canScroll || this.scroller.scrollLeft <= 2;
    const isAtEnd = !canScroll || this.scroller.scrollLeft >= maxScroll - 2;

    this.controls.hidden = !canScroll;
    this.controls.classList.toggle('is-hidden', !canScroll);
    this.controls.setAttribute('aria-hidden', String(!canScroll));

    this.setButtonHidden(this.prevBtn, isAtStart);
    this.setButtonHidden(this.nextBtn, isAtEnd);
  }

  setButtonHidden(button, isHidden) {
    button.hidden = isHidden;
    button.classList.toggle('is-hidden', isHidden);
    button.setAttribute('aria-hidden', String(isHidden));
    button.setAttribute('aria-disabled', String(isHidden));
  }
}

function initTrustZoneSections(scope = document) {
  const sections = scope.matches?.('.trust-zone-section')
    ? [scope]
    : Array.from(scope.querySelectorAll('.trust-zone-section'));

  sections.forEach((section) => {
    if (section.__trustZoneControls) {
      section.__trustZoneControls.update();
      return;
    }

    section.__trustZoneControls = new TrustZoneControls(section);
  });
}

if (!window.customElements.get('cos-trust-zone')) {
  window.customElements.define('cos-trust-zone', TrustZoneSection);
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => initTrustZoneSections(), { once: true });
} else {
  initTrustZoneSections();
}

document.addEventListener('shopify:section:load', (event) => {
  initTrustZoneSections(event.target);
});
